import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import Tooltip        from 'src/components/Tooltip'
import TippingText    from './TippingText'
import TippingSelect  from './TippingSelect'

export const Disclaimer = ({ i18n }) =>
  i18n.t('pledge_covers_fees.disclaimer') &&
  <Tooltip html title={
    i18n.t('pledge_covers_fees.disclaimer').replace(
      /((\$\s*)?1[^0]*000[\s\$]*USD)/,
      '<span class="text-nowrap">$1</span>'
    )
  }>
    <FontAwesomeIcon icon={faInfoCircle} />
  </Tooltip>

// Tip picker is always the select + "Other" free-form field. A
// radio-button variant (with an ascending star illustration per option)
// used to live behind the `tipping_ui` PWC setting; it was retired in
// August 2026 with nothing in production still pointing at it.
const Tipping = ({
  i18n, donation, errors, goal_partner_item, show_input_labels
}) => {
  const isNonprofit = goal_partner_item.beneficiary.type == 'Organization'
  const resolveKey = key => isNonprofit ? `${key}_nonprofit` : key
  const resolveTranslation = key => i18n.t(resolveKey(key))

  return (
    <div>
      <h2 className="h5 mt-4 section-heading section-heading-tipping">
        {i18n.t('tip_heading')}<span aria-hidden="true"> 💜</span>
      </h2>
      <p className="mb-3">
        {resolveTranslation(
          goal_partner_item.pledge_covers_credit_card_fees
          ? 'tip_copy_ftf'
          : 'tip_copy_vanilla'
        )}
        {' '}
        {
          goal_partner_item.pledge_covers_credit_card_fees &&
          <Disclaimer i18n={i18n} />
        }
      </p>

      <div className="mb-3 mt-n2">
        {
          show_input_labels &&
          <label
            className="form-label mt-2"
            htmlFor={donation.state.otherTip ? 'tip' : 'tipOption'}
            aria-hidden="true"
          >{i18n.t('tip_label')}</label>
        }
        <div className="d-flex gap-2 mb-n3">
          <TippingSelect i18n={i18n} donation={donation} />
          {
            donation.state.otherTip &&
            <TippingText
              i18n={i18n}
              donation={donation}
              errors={errors}
              label={i18n.t('other_tip_label')}
              labelClass="visually-hidden"
            />
          }
        </div>
      </div>
      {(() => {
        if (donation.bigAmount.eq(0) || donation.tip != 0) return null
        const copy = resolveTranslation('tip_zero')
        if (!copy) return null

        return (
          <div className="alert alert-warning d-flex align-items-center">
            <div className="me-3" style={{ fontSize: '2em' }}>
              {i18n.t('tip_zero_emoji')}
            </div>
            <small>{copy}</small>
          </div>
        )
      })()}
    </div>
  )
}

export default Tipping
